import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export function SearchResultsHitsHolder({ children }: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {children}
    </div>
  );
}
